import { useState } from "react"
import BaseButton from "../../../components/elements/BaseButton"
import { useNavigate } from "react-router-dom"
import { ReactComponent as ARROW } from "../../../assets/ArrowTurnDown.svg"
import { ReactComponent as CLOSE } from "../../../assets/CloseICON.svg"
import { ReactComponent as OFFER } from "../../../assets/OfferIcon.svg"
import { ReactComponent as MAJORORDER } from "../../../assets/Auftrag.svg"
import { ReactComponent as BILL } from "../../../assets/BillIcon.svg"
import { ReactComponent as BILLTEMPLATE } from "../../../assets/BillTemplate.svg"
import { ReactComponent as PAYMENT } from "../../../assets/PaymentIcon.svg"
import { ReactComponent as TRANSACTION } from "../../../assets/EuroICON.svg"
import { Euro } from "lucide-react"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"

type FloatingActionButtonType = {
    currentPage: string
}

export default function FloatingActionButton(props: FloatingActionButtonType) {
    const [showLinks, setShowLinks] = useState<boolean>(false)
    const navigate = useNavigate()
    return (
        <div className="fixed bottom-8 right-8 flex gap-2 md:flex-row flex-col items-end z-10">
            {showLinks && (
                <div className="flex flex-col md:flex-row gap-2">
                    {props.currentPage !== "offer" && <BaseButton label={"Angebote"} func={() => navigate("/buchhaltung/angebote")} icon={<OFFER className="w-6 h-6" />} />}
                    {props.currentPage !== "credit" && <BaseButton label={"Gutschriften"} func={() => navigate("/buchhaltung/gutschriften")} icon={<Euro className="w-6 h-6" />} />}
                    {props.currentPage !== "major-order" && <BaseButton label={"Aufträge"} func={() => navigate("/buchhaltung/aufträge")} icon={<MAJORORDER className="w-6 h-6" />} />}
                    {props.currentPage !== "bill" && <BaseButton label={"Rechnungen"} func={() => navigate("/buchhaltung/rechnungen")} icon={<BILL className="w-6 h-6" />} />}
                    {props.currentPage !== "bill-template" && (
                        <BaseButton label={"Rechnungsvorlagen"} func={() => navigate("/buchhaltung/rechnungsvorlagen")} icon={<BILLTEMPLATE className="w-6 h-6" />} />
                    )}
                    <Authorized allOf={[P.buchhaltung_read]}>
                        {props.currentPage !== "pay-req" && <BaseButton label={"Zahlungen"} func={() => navigate("/buchhaltung/zahlungen")} icon={<PAYMENT className="w-6 h-6" />} />}
                        {props.currentPage !== "transaction" && <BaseButton label={"Transaktionen"} func={() => navigate("/buchhaltung/transaktionen")} icon={<TRANSACTION className="w-6 h-6" />} />}
                    </Authorized>
                </div>
            )}
            <button onClick={() => setShowLinks(!showLinks)} className="btn bg-white shadow-lg border-none hover:bg-white/40 btn-circle">
                {showLinks ? <CLOSE className="h-6 w-6" /> : <ARROW className="h-6 w-6" />}
            </button>
        </div>
    )
}
